var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"card",attrs:{"color":"primary"}},[_c('v-card-text',[_c('PreregistrosTable',{attrs:{"preregistros":_vm.preregistros}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }